/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Delete_EmptyInputs */

const cs_pipelines_delete_empty = /** @type {(inputs: Pipelines_Delete_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tuto pipeline? Tuto akci nelze vrátit.`)
};

const en_pipelines_delete_empty = /** @type {(inputs: Pipelines_Delete_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this pipeline? This cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Delete this pipeline? This cannot be undone." |
*
* @param {Pipelines_Delete_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_delete_empty = /** @type {((inputs?: Pipelines_Delete_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Delete_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_delete_empty(inputs)
	return cs_pipelines_delete_empty(inputs)
});